import type { ErrorHandler } from '@angular/core';

/** Больше держать смысла нет: Sentry подключается сразу после старта приложения. */
const MAX_BUFFERED_ERRORS = 20;

/**
 * Sentry грузится лениво, поэтому ошибки, упавшие до его готовности, нужно где-то сохранить —
 * иначе они исчезнут без следа.
 */
export class BufferedErrorHandler implements ErrorHandler {
  #buffered: unknown[] = [];
  #forward: ((error: unknown) => void) | null = null;

  handleError(error: unknown): void {
    if (this.#forward) {
      this.#forward(error);

      return;
    }

    if (this.#buffered.length < MAX_BUFFERED_ERRORS) {
      this.#buffered.push(error);
    }
  }

  /** Подключает приёмник и отдаёт ему всё, что накопилось до его появления. */
  connect(forward: (error: unknown) => void): void {
    this.#forward = forward;

    const buffered = this.#buffered;
    this.#buffered = [];
    buffered.forEach((error) => forward(error));
  }
}
